__webpack_require__.p = "https://bmidxbukplpreprod.netlify.app/";